import { useParams } from "react-router";
import { useOmniContractShowQuery } from "@/services/backend/omni/contract/api/contract-api";
import { ContractDataPage } from "@/services/backend/omni/contract/components/contract-data-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function ContractDataRoute() {
  const { contractId } = useParams();

  const { data, isLoading, error } = useOmniContractShowQuery({
    id: contractId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && <ContractDataPage contract={data} />}
    </div>
  );
}
